import Quill from 'quill';
import { useCallback } from 'react';

import { FontAwesomeIcon } from '@hivebrite/design-system/FontAwesomeIcon';

import { useQuillEditorContext } from 'hb-react/shared/components/DesignSystem/QuillEditor/contexts/QuillEditorContext';
import ToolbarItem from 'hb-react/shared/components/DesignSystem/QuillEditor/Toolbar/components/ToolbarItem';

const Divider = () => {
  const { quillRef, setForceEditorFocus } = useQuillEditorContext();

  const handleDivider = useCallback(() => {
    const range = quillRef.current?.getSelection(true);

    quillRef.current?.insertEmbed(
      range?.index ?? 0,
      'divider',
      true,
      Quill.sources.USER,
    );
  }, [quillRef]);

  return (
    <ToolbarItem
      onMouseDown={() => setForceEditorFocus?.(true)}
      onClick={handleDivider}
      icon={<FontAwesomeIcon iconName="horizontal-rule" height="16px" />}
      dataTestId="divider-action"
      ariaLabel={s__('QuillEditorAccessibility|Add an horizontal line')}
      tooltip={s__('QuillEditorAccessibility|Add an horizontal line')}
      enableFontAwesomeIcon
    />
  );
};

export default Divider;
